var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    [
      _c(
        "router-link",
        {
          attrs: {
            to: {
              name: "payments.show",
              params: {
                bookingId: _vm.payment.booking_id,
                paymentId: _vm.payment.id,
                action: "process",
              },
            },
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-6" },
              [_c("h3", [_vm._v(_vm._s(_vm.bookingPaymentType))])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6 col-sm-2 col-md-2 col-lg-2" }, [
              _vm.bookingPaymentIsOverdue
                ? _c("p", [
                    _c("span", { staticClass: "label label-danger" }, [
                      _vm._v("Overdue"),
                    ]),
                  ])
                : _vm.bookingPaymentIsUnpaid
                ? _c("p", [
                    _c("span", { staticClass: "label label-info" }, [
                      _vm._v("Unpaid"),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-6 col-sm-5 col-md-5 col-lg-3" }, [
              _c("p", [
                _c("i", { staticClass: "fa fa-calendar" }),
                _vm._v(
                  " Due By: " +
                    _vm._s(
                      _vm._f("date")(
                        _vm.payment.due_date,
                        _vm.$user.date_format_preference
                      )
                    )
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "price" }, [
            _c("span", { staticClass: "amount" }, [
              _vm._v(
                _vm._s(
                  _vm._f("currency")(
                    _vm.payment.total_inclusive,
                    _vm.payment.currency
                  )
                )
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }